// Expose jQuery as a global BEFORE any jQuery plugin is imported.
// The legacy asset code (and every copied jQuery plugin) expects
// window.$ / window.jQuery to already exist at evaluation time.
//
// Pinned to 1.12.4 to match what jquery-rails' `//= require jquery` shipped.
// The app stays on jQuery 1.x deliberately: Bootstrap 2.3.2's dropdown passes
// a bare "#" to $() (from href="#"), which jQuery 3.x rejects with
// "unrecognized expression: #". Do not bump without auditing that.
import jQuery from "jquery"

window.$ = window.jQuery = jQuery

export default jQuery
